import {SimpleAPIError} from './SimpleAPIError'

export class SimpleAPIInvalidCSRFError extends SimpleAPIError {
  kind = 'invalidCSRF' as const

  public toHumanString(): string {
    return 'Invalid CSRF token.'
  }
}
